import { MoneyValueDto } from '@/types/MoneyValueDto';

/**
 * Dyskryminator alokacji. Backend serializuje `TransactionAllocationDto`
 * polimorficznie po polu `type` — bez niego żądanie nie przechodzi
 * deserializacji, więc każda alokacja musi je nieść.
 */
export enum TransactionAllocationType {
  BOOKING = 'BOOKING',
  EXPENSE = 'EXPENSE',
}

interface TransactionAllocationBase {
  id?: string;
  amount: MoneyValueDto;
  notes?: string | null;
}

/** Wpłata przypisana do rezerwacji — pieniądz wchodzi, kwota dodatnia. */
export interface BookingTransactionAllocationDto
  extends TransactionAllocationBase {
  type: TransactionAllocationType.BOOKING;
  bookingId: string;
}

/** Zapłata przypisana do zaplanowanego wydatku — pieniądz wychodzi, kwota ujemna. */
export interface ExpenseTransactionAllocationDto
  extends TransactionAllocationBase {
  type: TransactionAllocationType.EXPENSE;
  expensePlannedTransactionId: string;
}

export type TransactionAllocationDto =
  | BookingTransactionAllocationDto
  | ExpenseTransactionAllocationDto;

export const isBookingAllocation = (
  allocation: TransactionAllocationDto,
): allocation is BookingTransactionAllocationDto =>
  allocation.type === TransactionAllocationType.BOOKING;
